var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 24",
    id: "css",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.366 21.423 1.913-21.423h-21.279l.025.278 1.885 21.148.016.176 8.633 2.398h.136l8.653-2.4.016-.176zm-8.708-16.744h6.183l-.186 2.16-6.1 2.712.102.488h5.724l-.659 7.551-5.086 1.41-5.084-1.408-.32-3.616h2.093l.168 1.833.016.178 3.085.82h.133l3.051-.848.015-.177.288-3.386.023-.276h-9.047l-.19-2.173 6.309-2.701-.1-.49h-6.48l-.185-2.08h6.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.1586f10d4948e92a83a5a71e1a3fd5a3.svg";
export { ForwardRef as ReactComponent };